import { Breadcrumb } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import BreadcrumbName from "./BreadcrumbName.component";

const HomeBreadcrumb = () => {
  const navigate = useNavigate();
  return (
    <Breadcrumb.Item onClick={() => navigate("/")}>
      <BreadcrumbName currentName="Home" />
    </Breadcrumb.Item>
  );
};

export default HomeBreadcrumb;
